const copyTextToClipBoard = (event) => {
  event.preventDefault();
  window.navigator.clipboard.writeText(event.target.value);
};

export default copyTextToClipBoard;
